module.exports = __webpack_public_path__ + "static/img/v10.cb5807f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/v10.svg
// module id = TWF8
// module chunks = 0